module.exports = __webpack_public_path__ + "static/media/29EUNOG20.b51ec063.jpg";